import { fetchData } from '../../../http/Http';
import { AuthorModel } from '../models/AuthorModel';

export const fetchAuthorById = async (id: string) => {
    try {
        const response = await fetchData(`/authors/${id}`, 'GET');
        return response.data;
    } catch (e) {
        console.error('Error retrieving author information: ', e);
        return null;
    }
};

export const searchAuthors = async (params: {
    query: string;
    page?: string;
    limit?: string;
}): Promise<{ data: AuthorModel[]; meta: any }> => {
    try {
        return await fetchData(`/authors/search?${new URLSearchParams(params).toString()}`, 'GET');
    } catch (e) {
        console.error('Error retrieving search authors: ', e);
        return { data: [], meta: {} };
    }
};
